import { render, staticRenderFns } from "./AdminPassword.vue?vue&type=template&id=877f0b28&scoped=true&"
import script from "./AdminPassword.vue?vue&type=script&lang=js&"
export * from "./AdminPassword.vue?vue&type=script&lang=js&"
import style0 from "./AdminPassword.vue?vue&type=style&index=0&id=877f0b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877f0b28",
  null
  
)

export default component.exports